import {
  Gift, TreePine, Star, Snowflake, Bell, Candy, Trophy, Medal, Award,
  GraduationCap, BookOpen, Users, Download, FileText, Calculator, Pencil,
  Sparkles, Heart, Music, BarChart3, Newspaper, Puzzle, Crown, Rocket,
  Lightbulb, Info, Calendar, Mail, Gamepad2, PartyPopper,
  ShoppingCart, Store, Tag, ShoppingBag,
  ScrollText, Files,
} from "lucide-react";

// Curated icon set for home buttons (festive + education themed).
export const BUTTON_ICONS = {
  gift: { label: "Presente", Comp: Gift },
  tree: { label: "Árvore de Natal", Comp: TreePine },
  star: { label: "Estrela", Comp: Star },
  snowflake: { label: "Floco de neve", Comp: Snowflake },
  bell: { label: "Sino", Comp: Bell },
  candy: { label: "Bengala doce", Comp: Candy },
  party: { label: "Festa", Comp: PartyPopper },
  sparkles: { label: "Brilhos", Comp: Sparkles },
  trophy: { label: "Troféu", Comp: Trophy },
  medal: { label: "Medalha", Comp: Medal },
  award: { label: "Prémio/Diploma", Comp: Award },
  diploma: { label: "Diploma", Comp: ScrollText },
  diplomas: { label: "Vários diplomas", Comp: Files },
  crown: { label: "Coroa", Comp: Crown },
  graduation: { label: "Chapéu de finalista", Comp: GraduationCap },
  book: { label: "Livro", Comp: BookOpen },
  users: { label: "Turma/Pessoas", Comp: Users },
  calculator: { label: "Calculadora", Comp: Calculator },
  pencil: { label: "Lápis", Comp: Pencil },
  puzzle: { label: "Puzzle/Passatempo", Comp: Puzzle },
  game: { label: "Jogo", Comp: Gamepad2 },
  chart: { label: "Estatísticas", Comp: BarChart3 },
  newspaper: { label: "Novidades", Comp: Newspaper },
  download: { label: "Descarregar", Comp: Download },
  file: { label: "Documento", Comp: FileText },
  rocket: { label: "Foguetão", Comp: Rocket },
  lightbulb: { label: "Ideia", Comp: Lightbulb },
  heart: { label: "Coração", Comp: Heart },
  music: { label: "Música", Comp: Music },
  calendar: { label: "Calendário", Comp: Calendar },
  mail: { label: "Email", Comp: Mail },
  info: { label: "Informação", Comp: Info },
  cart: { label: "Carrinho de compras", Comp: ShoppingCart },
  store: { label: "Loja", Comp: Store },
  bag: { label: "Saco de compras", Comp: ShoppingBag },
  tag: { label: "Etiqueta/Preço", Comp: Tag },
};

export const BUTTON_ICON_OPTIONS = Object.entries(BUTTON_ICONS).map(([v, x]) => ({ v, label: x.label }));

// Resolve an icon name to its component; falls back to the provided default.
export function getButtonIcon(name, fallback = FileText) {
  return (name && BUTTON_ICONS[name]?.Comp) || fallback;
}
